<div
  [ngClass]="{
    active: activate,
    'top-border': showTopBorder
  }"
  class="accordion-wrapper"
>
  <button
    #button
    type="button"
    (key.enter)="toggleOpen()"
    (click)="toggleOpen()"
    class="accordion"
    [attr.aria-expanded]="activate"
    data-test-id="accordion-header"
  >
    <div class="header-wrapper">
      <i
        *ngIf="showArrow"
        class="accordion-arrow"
        [ngClass]="activate ? 'down' : 'right'"
        data-test-id="icon-profile"
      >
        <cigna-icon
          [type]="activate ? caretDownIcon : caretRightIcon"
        ></cigna-icon>
      </i>
      <ng-content select=".header"></ng-content>
      <cigna-icon
        *ngIf="showRightArrow"
        class="arrow"
        [ngClass]="activate ? 'arrow-up' : 'arrow-down'"
        type="arrow-ic"
      ></cigna-icon>
    </div>
    <div *ngIf="activate" class="description-wrapper">
      <ng-content select=".description"></ng-content>
    </div>
  </button>

  <ng-content select=".sub-header"></ng-content>

  <div
    class="panel"
    [ngClass]="activate ? 'accordionOpened' : 'accordionClosed'"
    data-test-id="accordion-panel"
  >
    <ng-content select=".content"></ng-content>
  </div>
</div>
